import { render, staticRenderFns } from "./addFixedAssetType.vue?vue&type=template&id=b8470d34&scoped=true&"
import script from "./addFixedAssetType.vue?vue&type=script&lang=js&"
export * from "./addFixedAssetType.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b8470d34",
  null
  
)

export default component.exports